import React, { createContext, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { openLogin, closeLogin } from '../store/slices/uiSlice';

const LoginModalContext = createContext({
  isLoginOpen: false,
  openLogin: () => {},
  closeLogin: () => {},
});

export const LoginModalProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isLoginOpen = useSelector((state) => state.ui.isLoginOpen);

  const handleOpenLogin = (options) => dispatch(openLogin(options));
  const handleCloseLogin = () => dispatch(closeLogin());

  return (
    <LoginModalContext.Provider value={{ 
      isLoginOpen, 
      openLogin: handleOpenLogin, 
      closeLogin: handleCloseLogin 
    }}>
      {children}
    </LoginModalContext.Provider>
  );
};

export const useLoginModal = () => useContext(LoginModalContext); 